import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import type { SelectedEntity } from '@common/types/layout.type';

import type { NormalizedColumnEntity, NormalizedSectionEntity } from '@web/types';

import { ColumnsFacade } from '@web/store/page-structure/columns/columns.facade';

import { NavigationColumnItemComponent } from '../navigation-column-item';

@Component({
    selector: 'web-navigation-section-item',
    templateUrl: './navigation-section-item.component.html',
    styleUrls: ['./navigation-section-item.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NavigationColumnItemComponent],
})
export class NavigationSectionItemComponent {
    public readonly entity = input.required<NormalizedSectionEntity>();
    public readonly index = input.required<number>();
    public readonly selectedEntity = input.required<SelectedEntity>();

    private readonly columnsFacade: ColumnsFacade = inject(ColumnsFacade);

    private readonly columnsEntities = toSignal(this.columnsFacade.columnsEntities$, { initialValue: {} });

    public readonly columns = computed(() => {
        const columns = this.columnsEntities();
        return this.entity().children.map((columnId) => columns[columnId] as NormalizedColumnEntity);
    });
}
